export const posibleFirebaseErrors = {
    userNotFound: "auth/user-not-found",
    invalidPassword: "auth/wrong-password"
}